import React from 'react';
import './styles.css';
import { Pickup } from '../../Api/interfaces';
import './styles.css';

interface Props {
  pickUp: Pickup;
}

export default class PickupRow extends React.Component<Props> {
  render(): JSX.Element {
    const { pickUp } = this.props;
    const colorText = pickUp.color;
    return (
      <tr>
        <td valign="top">
          {pickUp.imageUrl ? (
            <img
              width="16"
              height="16"
              src={pickUp.imageUrl}
              alt={pickUp.displayValue}
            />
          ) : null}
        </td>
        <td valign="top">
          {pickUp.color ? (
            <div style={{ color: colorText }}>{pickUp.displayValue} </div>
          ) : (
            <div>{pickUp.displayValue} </div>
          )}
        </td>
        <td valign="top">
          <div>{pickUp.value}</div>
        </td>
        <td valign="top">
          {pickUp.color ? (
            <div style={{ color: colorText }}>[{pickUp.color}]</div>
          ) : (
            <div>-</div>
          )}
        </td>
        <td valign="top">
          <div>{pickUp.description}</div>
        </td>
      </tr>
    );
  }
}
